module.exports = __webpack_public_path__ + "img/resolve-bg.f613bb0a.png";